module.exports = __webpack_public_path__ + "img/bim (6).8fd66b74.png";